export default "__VITE_ASSET__B2UzDD$0__"